import { Empty } from 'antd';
import React from 'react';
import styled from 'styled-components';

export const EmptyDataContainerStyled = styled.div`
  background-color: white;
  width: 100%;
  color: rgba(0, 0, 0, 0.25);
  .ant-empty-normal {
    color: inherit;
  }
`;

const EmptyData: React.FC = () => (
  <EmptyDataContainerStyled className='gx-p-2 empty-data-default'>
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  </EmptyDataContainerStyled>
);

export default EmptyData;
